import * as React from "react";
import { isValid } from "date-fns";
import { Text } from "@grandvisionhq/elements";
import { useIntl } from "@grandvisionhq/state";
import { useAppointmentSlots } from "../../../../../pages/BookAppointment/context/v3/pages/BookAppointment/context/appointment-slots.js";
/* empty css                                 */
const AppointmentConfirmationTime = ({
  appointmentType,
  startTime,
  endTime
}) => {
  const { Slots } = useAppointmentSlots();
  const { getLabel, dateTime } = useIntl();
  const durationLabel = appointmentType?.duration ? appointmentType.duration.amount > 0 ? ` (${appointmentType.duration.amount} ${getLabel(
    `appointments.shortTimeUnits.${appointmentType.duration.unit.toLowerCase()}`
  )})` : "" : "";
  return /* @__PURE__ */ React.createElement("div", { className: "appointment-confirmation-time__details" }, appointmentType && /* @__PURE__ */ React.createElement(Text, { variant: "body-head" }, appointmentType.name, durationLabel), isValid(startTime) && isValid(endTime) && /* @__PURE__ */ React.createElement("div", { className: "appointment-confirmation-time__date-time", "data-t": "address-data" }, Slots?.confirmationTime ? Slots?.confirmationTime({
    startTime,
    endTime
  }) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Text, null, dateTime.formatLongDate(startTime)), /* @__PURE__ */ React.createElement(Text, null, dateTime.formatTime(startTime)))));
};
export {
  AppointmentConfirmationTime,
  AppointmentConfirmationTime as default
};
//# sourceMappingURL=AppointmentConfirmationTime.js.map
